@if (showStatus) {
  <div
    class="status-info"
    (click)="stopPropagation($event)"
    (keydown.enter)="stopPropagation($event)"
    (keydown.space)="stopPropagation($event)">
    <mtm-status-select
      [value]="getCurrentStatus()"
      [options]="assetStatusOptions"
      [fallbackOption]="notAffectedOption"
      [disabled]="isDropdownDisabled()"
      (valueChange)="onChangeStatus($event.value)" />
  </div>
}
